/* eslint-disable react/forbid-dom-props */
/**
 * Tabs component script class
 *
 * @package    Common
 * @author     Vadym Karpenko <vadym.karpenko@door3.com>
 */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';
import deepEqual from 'deep-equal';
import cx from 'classnames';

import './styles.scss';

import {
    updateItemLocal,
} from 'Actions/invite';
import {
    RSVP_PROCESS_INTRODUCTION,
    RSVP_PROCESS_PERSONAL,
    STATUS_DECLINE,
    STATUS_PENDING,
    LOCATION_PREFIX,
} from 'Constants';
import {
    registrationType,
    settingsDataType,
} from 'Types/event';

const TAB_LIST = [
    'permission',
    'introduction',
    'personal-information',
    'documents',
    'companions',
    'complete',
];

@connect(
    (store) => ({
        loaded: store.invite.loaded,
        preview: store.invite.preview,
        registration: store.registration.data,
        rsvp: store.invite.data.rsvp,
        settings: store.invite.data.settings,
    }),
    (dispatch) => ({
        updateItemLocal: (data) => dispatch(updateItemLocal(data)),
    }),
)
export default class Tabs extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        loaded: PropTypes.bool.isRequired,
        pathname: PropTypes.string.isRequired,
        preview: PropTypes.bool.isRequired,
        registration: registrationType,
        rsvp: PropTypes.string,
        search: PropTypes.string,
        settings: settingsDataType,
        updateItemLocal: PropTypes.func.isRequired,
    };

    /**
     * @type {Object}
     */
    static defaultProps = {
        registration: null,
        rsvp: '',
        search: undefined,
        settings: {},
    };

    state = {
        width: null,
    };

    componentDidMount () {
        this.calculateWidth();
    }

    componentDidUpdate (prevProps) {
        if (!deepEqual(prevProps.registration, this.props.registration)) {
            this.calculateWidth();
        }
    }

    calculateWidth = () => {
        const { registration } = this.props;

        if (registration?.banner?.src && !registration?.bannerSettings?.full) {
            const img = new Image();
            const setState = this.setState.bind(this);

            img.onload = function () {
                setState({
                    width: this.width,
                });
            };
            img.src = registration?.banner?.src;
        }
    };

    onClick = (event) => {
        const { preview } = this.props;

        if (!preview) {
            event.preventDefault();
            event.stopPropagation();
        }
    };

    updateRSVP = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const { updateItemLocal } = this.props;

        updateItemLocal({
            rsvp: STATUS_PENDING,
            rsvpProcess: RSVP_PROCESS_INTRODUCTION,
        });
    };

    updatePersonalInfo = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const { updateItemLocal } = this.props;

        updateItemLocal({
            rsvp: STATUS_PENDING,
            rsvpProcess: RSVP_PROCESS_PERSONAL,
        });
    };

    render () {
        const { loaded, pathname, preview, rsvp, search, settings } = this.props;
        const { width } = this.state;

        if (!loaded) {
            return null;
        }

        return (
            <ul
                className="nav nav-pills nav-justified registration-tabs"
                style={ {
                    maxWidth: width ? `calc(${ width }px + 10vw` : undefined,
                } }
            >
                { TAB_LIST.filter((tab) => {
                    if (tab === 'permission' && !settings.secure?.password && !settings.secure?.email) {
                        return false;
                    }
                    if (tab === 'documents' && !settings.documents?.enabled) {
                        return false;
                    }
                    if (tab === 'companions' && !settings.companions?.enabled) {
                        return false;
                    }
                    if (tab === 'introduction' && !settings.landingTab?.enabled) {
                        return false;
                    }

                    return true;
                }).map((tab, index) => (
                    <li className="nav-item registration-tabs-item" key={ tab }>
                        <NavLink
                            className={ cx('registration-tabs-item-link', 'nav-link', { disabled: !preview }) }
                            onClick={ this.onClick }
                            to={ {
                                pathname: `${ LOCATION_PREFIX }/${ tab }`,
                                search,
                            } }
                        >
                            <span className="registration-tabs-item-link-number">{ index + 1 }</span>
                            { (tab !== 'introduction' || !settings?.landingTab?.tabName) &&
                            <FormattedMessage id={ `tabs.${ tab }` } tagName="span"/> }
                            { (tab === 'introduction' && settings?.landingTab?.tabName) && settings.landingTab.tabName }
                            { tab === 'introduction' && pathname === `${ LOCATION_PREFIX }/complete`
                            && settings?.permissions?.canUpdateRSVP && (<button
                                className="btn btn-primary registration-tabs-item-link-btn"
                                onClick={ this.updateRSVP }
                                type="button"
                            >
                                <FormattedMessage id="buttons.edit"/>
                            </button>) }
                            { tab === 'personal-information' && rsvp !== STATUS_DECLINE
                            && pathname === `${ LOCATION_PREFIX }/complete`
                            && settings?.permissions?.canUpdatePersonalInfo && (<button
                                className="btn btn-primary registration-tabs-item-link-btn"
                                onClick={ this.updatePersonalInfo }
                                type="button"
                            >
                                <FormattedMessage id="buttons.edit"/>
                            </button>) }
                        </NavLink>
                    </li>
                )) }
            </ul>
        );
    }
}
